var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80895 -3.52859e-05C7.66222 -0.000884056 7.51677 0.0272398 7.38093 0.0827236C7.24509 0.138206 7.12154 0.219957 7.01736 0.323289L0.327887 7.01277C0.117944 7.22271 0 7.50745 0 7.80435C0 8.10126 0.117944 8.386 0.327887 8.59594C0.537829 8.80588 0.822572 8.92383 1.11947 8.92383C1.41638 8.92383 1.70112 8.80588 1.91106 8.59594L7.80895 2.6869L13.7068 8.58479C13.9201 8.76744 14.1945 8.86289 14.4751 8.85205C14.7557 8.84121 15.0218 8.72489 15.2204 8.52633C15.419 8.32777 15.5353 8.0616 15.5461 7.781C15.557 7.5004 15.4615 7.22605 15.2789 7.01277L8.58939 0.323289C8.38173 0.117315 8.10144 0.00119591 7.80895 -3.52859e-05Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.06c656a42c472731593fc38c0816e944.svg";
export { ForwardRef as ReactComponent };